var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Resource"}},[_vm._t("default",function(){return [(true)?_c('router-view',{staticClass:"main-wrapper"}):_vm._e()]})],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }